import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { branch, compose, renderComponent, setPropTypes } from 'recompose';
import { NumberFormField } from '../../components';
import Loading from '../../pages/loading';

const CpdPointsSetting = ({
  industry,
  validationMessages,
  onIndustryChange,
  planLocked
}) => (
    <Row>
      <Col xs={8} xsOffset={2}>
        <NumberFormField
          id='total-cpd-points'
          label={null}
          disabled={planLocked}
          inputProps={{ disabled: planLocked }}
          validation={validationMessages.totalCpdPoints}
          value={industry.cpdPoints}
          onChange={(e) => onIndustryChange('cpdPoints', e.value, 0, industry)}
          required
          min={0}
          formFieldProps={{ formItemProps: { className: 'centered' } }} />
      </Col>
    </Row>
  );

export default compose(
  setPropTypes({
    industry: PropTypes.object,
    isLoading: PropTypes.bool,
    onIndustryUserChange: PropTypes.func,
    validationMessages: PropTypes.object,
    planLocked: PropTypes.bool
  }),
  branch(
    ({ isLoading }) => isLoading,
    renderComponent(Loading)
  )
)(CpdPointsSetting);



// WEBPACK FOOTER //
// ./src/containers/partials/cpd-settings/cpd-points-setting.js